var map = {
	"./007-microphone-1.png": 335,
	"./010-home.png": 336,
	"./013-document-1.png": 337,
	"./014-document.png": 338,
	"./015-color-palette.png": 339,
	"./017-video-camera.png": 340,
	"./image.png": 377,
	"./label.png": 378,
	"./left.svg": 379,
	"./right.svg": 380
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 594;